import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Dashboards

const Home = Loader(lazy(() => import("src/content/home")));

const dashboardsRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Anasayfa </title>
        </Helmet>
        <Home />
      </>
    ),
  },
];

export default dashboardsRoutes;
